// nelle pagine che usano esa-cards e nella barra info dei tornei
import Tooltip from 'bootstrap/js/dist/tooltip';

export default function (container = document) {

  if(window.process === undefined) {
    window.process = { env: { NODE_ENV: 'production' } }; // safari non supporta l'operatore ??=
  }

  container.querySelectorAll('[data-bs-toggle="tooltip"].esa-card-punti-badge').forEach(el => {
    // el.dataset.title = el.title;
    el.title = '<strong>' + el.title + '</strong><br><br>' +
    'Acquisisci punti e colleziona i vari badge: avrai accesso a sconti e contenuti dedicati!';
  });
  container.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new Tooltip(el, {
      placement: 'auto',
      container: 'body',
      // trigger: 'click',
      html: true
    });

  });
}
